import { SeatApi } from '@linktivity/hirakuza';
import config from '../config';

const seatApi = new SeatApi(config);

export default seatApi;
